import { cn } from '@moreharvest/component-library';

const noBorderWrapperClasses = cn(
    'flex flex-col m-auto w-full px-4 h-full items-center justify-center',
    'w-full lg:m-auto lg:flex lg:max-w-[424px]',
    'bg-base-background dark:bg-base-background-dark'
);

const NoBorderWrapper = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
    <div className={cn(noBorderWrapperClasses, className)} {...props} />
);

export default NoBorderWrapper;
